module.exports = __webpack_public_path__ + "static/media/linear-profile.b50d85cc.svg";